import React from "react"
import { css } from "@emotion/core"
import { Link, graphql } from "gatsby"
import Layout from "../components/layout"

function JobsPage(props) {
  return (
    <Layout>
      <div
        css={css`
          max-width: 640px;
          padding: 0 20px;
          margin: 0 auto;
          margin-top: 60px;
          margin-bottom: 60px;
        `}
      >
        <p>
          Hi — we’re Satchel, and we help startups make more informed decisions
          about SaaS. We{" "}
          <a href="https://news.ycombinator.com/item?id=23236319">
            recently launched on Hacker News
          </a>
          .
        </p>

        <p>
          We’ve derisked many aspects of the business. We have promising signs
          of early product-market fit and a lengthy amount of runway. We're also
          backed by a group of amazing founders, including Paul Graham, Paul
          Buchheit, and the team at Y Combinator.
        </p>

        <p>
          There are plenty of systemic problems throughout the world of B2B
          software, and we have aspirations to tackle them. However, we won't
          earn the privilege of doing so until we nail our first product — an
          unrivaled collection of guides to SaaS. To accomplish this, we'll need
          to continue on our current trajectory: doing great research and
          writing great content.
        </p>

        <p>
          We're looking for a writer to help us pursue this goal. We use the
          word writer loosely — we imagine the role may very well turn out to be
          a GM of Content or a Head of Research.
        </p>

        <p>
          We understand that the best people may have unconventional
          backgrounds, so we'll refrain from enumerating a prescriptive list of
          requirements. That said, we suspect a good fit might look like an
          investigative journalist with a technical bent or an engineer with a
          penchant for writing.
        </p>

        <p>We expect this role to be remote-first.</p>

        <p>
          If you're interested, please email me at{" "}
          <a href="mailto:andrew@satchel.com">andrew@satchel.com</a>. Thanks!
          <qed />{" "}
        </p>
      </div>
    </Layout>
  )
}

export default JobsPage
